import { customAlphabet } from 'nanoid'

const acceptedChars = '23456789abcdefghijkmnopqrstuvwxyz'

const nanoid = customAlphabet(acceptedChars, 15)

/**
 * createNanoId
 * @param scope - ID prefix. Make sure scope is 3 characters.
 */
export const createNanoId = (
  scope?: RecordScopes[keyof RecordScopes],
): string => {
  if (scope) {
    if (scope.length !== 3) {
      throw new Error('Scope must be 3 characters')
    }
    return `${scope}_${nanoid(11)}`
  }
  return nanoid(15)
}

export const RecordScopes = {
  apiToken: 'apt',
  channel: 'chl',
  channelLabel: 'chl',
  classification: 'cls',
  customer: 'cus',
  detection: 'dtc',
  extraction: 'xtr',
  evaluation: 'eva',
  evaluationScore: 'ecs',
  file: 'fil',
  flag: 'flg',
  highlight: 'hlt',
  highlightGroup: 'hlg',
  hotword: 'htw',
  interactionLabel: 'ilb',
  job: 'job',
  label: 'lbl',
  permission: 'prm',
  role: 'rol',
  scorecard: 'scr',
  scorecardCriteria: 'crt',
  scorecardCriteriaAssignment: 'cra',
  scorecardSection: 'sec',
  seed: 'sed',
  task: 'tsk',
  usage: 'usg',
  user: 'usr',
  workspace: 'wrk',
  event: 'evn',
  serviceQualityAnalysis: 'sqa',
  serviceQualityMoment: 'sqm',
  serviceQualityConcern: 'sqc',
  alert: 'alt',
  alertSubscriber: 'als',
  alertDelivery: 'ald',
  alertDigestDelivery: 'add',
  knowledgeArticle: 'kba',
} as const

export type RecordScopes = typeof RecordScopes
